<div class="fn-float-btn" [class]="floatBtnClass">
    <span class="fn-pulse-float"> <!--plum-pulse-float for plum schema -->
        @if (imgUrl) {
        <img [src]="cdnImageUrl + imgUrl" class="fn-help-img" [class]="imgClass">
        }
        @if (fnIcon) {
        <span><i class="blue" [class]="fnIcon"></i></span>
        }
    </span>
    <ul>
        @if(appVersion){
        <li class="app_version  border-0">
            <div class="version" [title]="appVersion">{{appVersion}}</div>
        </li>
        }
        @for (floatAction of floatActionList; track floatAction) {
        <li (click)="actionOnBtn.emit(floatAction)">
            <h5 [class]="floatAction.custClass">
                @if (floatAction.imgUrl) {
                <img [src]="cdnImageUrl + floatAction.imgUrl">
                }
                @if (floatAction.fnIcon) {
                <span><i class="blue" [class]="floatAction.fnIcon"></i></span>
                }
                {{floatAction.textDesc}}
            </h5>
        </li>
        }
    </ul>
</div>
